import styled from 'styled-components';

export const MobileAppRedirectContainer = styled.div`
	margin-top: ${({ theme }) => theme.spacing?.xxxxl};
	padding-top: ${({ theme }) => theme.spacing?.xxxxl};
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
`;

export const DownloadButton = styled.a`
	margin-top: ${({ theme }) => theme.spacing?.xl};
	padding: ${({ theme }) => theme.spacing?.medium}
		${({ theme }) => theme.spacing?.xxl};
	background-color: ${({ theme }) => theme.colors.primary.background.strong};
	color: white;
	font-size: 16px;
	font-weight: 600;
	text-decoration: none;
	border-radius: 8px;
	transition: background-color 0.2s ease;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }) =>
			theme.colors.primary.background.strongHover};
	}
`;
